import React from "react"
import { Accordion } from "@chakra-ui/accordion"
import { Box, Container, Tab, Tabs, TabList, TabPanel, TabPanels } from "@chakra-ui/react"
import AccordionMenu from "../components/accordion/AccordionMenu"
import { general, getStarted, features, sellerData, subscriptions } from "../data/FAQuestions"
import Meta from "../components/meta/Meta"

export default function FrequentlyAskedQuestions() {
  return (
    <>
      <Meta
        pageName={"Frequently Asked Questions - TrackSellers"}
        description={"Explore the answers to the most frequently asked questions about Amazon sellers, our features, seller data, subscriptions and how to get started."}
        hrefLink={"https://www.tracksellers.com/faq"}
      />
      <Box pt="4rem" pb="4rem">
        <Container maxW="container.lg">
          <Tabs colorScheme="orange">
            <TabList>
              <Tab _focus={{ boxShadow: "none" }}>General</Tab>
              <Tab _focus={{ boxShadow: "none" }}>Getting Started</Tab>
              <Tab _focus={{ boxShadow: "none" }}>Features</Tab>
              <Tab _focus={{ boxShadow: "none" }}>Seller Data</Tab>
              <Tab _focus={{ boxShadow: "none" }}>Subscriptions</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <Accordion w="100%" maxWidth="800px" m="auto" allowToggle defaultIndex={[0]} allowMultiple={false}>
                  {
                    general?.map((ques, index) => (<AccordionMenu {...ques} key={index} />))
                  }
                </Accordion>
              </TabPanel>
              <TabPanel>
                <Accordion w="100%" maxWidth="800px" m="auto" allowToggle defaultIndex={[0]} allowMultiple={false}>
                  {
                    getStarted?.map((ques, index) => (<AccordionMenu {...ques} key={index} />))
                  }
                </Accordion>
              </TabPanel>
              <TabPanel>
                <Accordion w="100%" maxWidth="800px" m="auto" allowToggle defaultIndex={[0]} allowMultiple={false}>
                  {
                    features?.map((ques, index) => (<AccordionMenu {...ques} key={index} />))
                  }
                </Accordion>
              </TabPanel>
              <TabPanel>
                <Accordion w="100%" maxWidth="800px" m="auto" allowToggle defaultIndex={[0]} allowMultiple={false}>
                  {
                    sellerData?.map((ques, index) => (<AccordionMenu {...ques} key={index} />))
                  }
                </Accordion>
              </TabPanel>
              <TabPanel>
                <Accordion w="100%" maxWidth="800px" m="auto" allowToggle defaultIndex={[0]} allowMultiple={false}>
                  {
                    subscriptions?.map((ques, index) => (<AccordionMenu {...ques} key={index} />))
                  }
                </Accordion>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Container>
      </Box>
    </>
  )
}